import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from "react-router-dom";
import { Helmet } from "react-helmet";
import OrderWebSocket from "./components/WebSocket/OrderWebSocket";
import OrderUpdateWebSocket from "./components/WebSocket/OrderUpdateWebSocket";

// Landing Page Imports
import Blogs from "./components/Landing_Page/Blogs";
import Post from "./components/Landing_Page/Post";
import Pricing from "./components/Landing_Page/Pricing";
import Contact from "./components/Landing_Page/Landing_Contact";
import Privacy from "./components/Landing_Page/Landing_Privacy";
import TAndC from "./components/Landing_Page/Landing_T&C";
import Cancellation from "./components/Landing_Page/Landing_Cancellation";
import LandingAbout from "./components/Landing_Page/Landing_AboutUs";
import Home from "./components/Landing_Page/Home_Page/Home_Page";
import Author from "./components/Landing_Page/Author";

// Dashboard Section Imports
import Dashboard from "./components/Dashboard/Dashboard";
// import Dashboard2 from "./components/Dashboard/Dashboard2";

// Main Landing Page Imports
import MyLanding from "./components/Main_Landing_Page/Main_Landing_Page";
import BuyPlan from "./components/Main_Landing_Page/Buy_Plan";
import GetStarted from "./components/Main_Landing_Page/GetStarted";

// Analytics Section Imports
import LeadDetails from "./components/Analytics/LeadDetails";
import LeadManagement from "./components/Analytics/Lead_Management";
import Analytics from "./components/Analytics/Analytics";
import { initGA, logPageView } from "./analytics";

// Whatsapp Section Imports
import CreateCampaignTool from "./components/Whatsapp/CreateCampaignTool";
import CampaignTool from "./components/Whatsapp/CampaignTool";
import CreateTemplate from "./components/Whatsapp/Create_Template";
import CampaignInsights from "./components/Whatsapp/CampaignInsights";
import Chats from "./components/Whatsapp/Chats";
import CreateCampaign from "./components/Whatsapp/Create Campaign";
import DLTTamplate from "./components/Whatsapp/TemplateStatus";
import Campaign from "./components/Whatsapp/Campaign";
import CampaignDetails from "./components/Whatsapp/campaign_details";
import CampaignView from "./components/Whatsapp/campaign_view";
import TemplateView from "./components/Whatsapp/template_view";
import TemplateEdit from "./components/Whatsapp/Template_Edit";
import ChatBot from "./components/Whatsapp/Chat_Bot";
import Logs from "./components/Whatsapp/Logs";
import ContactBook from "./components/Whatsapp/Contact_Book";
import ChatBotMain from "./components/Whatsapp/ChatBotMain";
import TemplateLibrary from "./components/Whatsapp/TemplateLibrary";
import EditLibrary from "./components/Whatsapp/LibraryEdit";

// Feed Section Imports
import FaceBookFeed from "./components/Feed/FaceBookFeed";
import AllPost from "./components/Feed/AllPost";
import Friends from "./components/Feed/Friends";
import FbTamplate from "./components/Feed/FB_Tamplate";
import FbCampaign from "./components/Feed/FB_Campaign";
import FbTamplateStatus from "./components/Feed/FB_Tamplate_Status";
import FbCampaignStatus from "./components/Feed/FB_Campaign_Status";
import FbLogs from "./components/Feed/FB_Logs";
import FbTemplateLibrary from "./components/Feed/FB_Tamplate_Librery";
import FbChatBot from "./components/Feed/FB_Chatbot";

//Order section Imports
import Order from "./components/Order/Order";
import Catalogue from "./components/Order/Catalogue";
import CatalogueTable from "./components/Order/CatalogueTable";
import Delivery from "./components/Order/Delivery ";
import PayOut from "./components/Order/PayOut";
import OrderSummary from "./components/Order/OrderSummary";
import Payment from "./components/Order/Payment";
import OrderSettingsCharges from "./components/Order/OrderSettings";
import BlockUser from "./components/Order/BlockUser";
import Dining from "./components/Order/Dining";
import TableQRCode from "./components/Order/QR_Code";
import DoorDash from "./components/Order/DoorDash/DoorDash";
import OrderGallery from "./components/Order/Gallery/OrderGallery"
import POS from "./components/Order/POS/Pos";
import POSOrderHistory from "./components/Order/POS/POS_Order_History";
import POSOrderSetting from "./components/Order/POS/PosOrderSetting/PosOrderSetting";
import ReportSection from "./components/Order/ReportSection"
import CustomerCreditManager from "./components/Order/Udhari/CustomerCreditManager";
import CreditTabs from "./components/Order/Udhari/CreditTabs";
import VendorManager from "./components/Order/Udhari/VendorManager";

//SupportTickets
import SupportTickets from "./components/Support/ClientSupportTickets";
// import TrackingPage from './TrackingPage';
import "./App.css";

// Admin Section imports
// Admin Section imports
import TopNav from "./components/Admin/NavbarAdmin";
import SideNav from "./components/Admin/AdminSideNav";
import ClientAnalyticsDashboard from "./components/Admin/Clients/ClientDashboard";
import EmployeeSectionCards from "./components/Admin/Employees/AdminEmployee";
import StatisticsDashboard from "./components/Admin/AdminStatic";
import PayoutSection from "./components/Admin/AdminPayoutSection";
import Login from "./components/Admin/AdminLogin";
import Clients from "./components/Admin/Clients/AdminClients";
import AdminOrders from "./components/Admin/Orders/AdminOrders";
import AdminBlog from "./components/Admin/Blogs/Blog";
import AdminAllBlogs from "./components/Admin/Blogs/Allblog";
import AdminEditBlogs from "./components/Admin/Blogs/Editblog";
import AdminLog from "./components/Admin/AdminLog";
import WhatsAppLogs from "./components/Admin/AdminWhatsApp";
import ChatComponent from "./components/Admin/AdminChat";
import AdminAuthors from "./components/Admin/Blogs/AdminAuthors";
import AdminLeadManagement from "./components/Admin/Clients/AdminLeadManagement";
import AdminLeadDetails from "./components/Admin/Clients/AdminLeadsDetails";
import AdminCatalogueTable from "./components/Admin/Clients/AdminCatelogueTable";
import AdminCatalogue from "./components/Admin/Clients/AdminAddCatelogue";
import AdminCampaign from "./components/Admin/Campaign/AdminCampaign";
import AdminCampaignView from "./components/Admin/Campaign/AdminCampaignView";
import AdminEditCampaign from "./components/Admin/Campaign/AdminEditCampaign";
import AdminTemplate from "./components/Admin/Templates/AdminTemplate";
import AdminTemplateView from "./components/Admin/Templates/AdminTemplateView";
import AdminSideNav from "./components/Admin/AdminSideNav";
import Support from "./components/Admin/Support/Support";
import AdminOrdersSetting from "./components/Admin/Orders/AdminOrdersSetting";
import AdminCampaigns from "./components/Admin/AdminCampaignLog";
import ClientBillingTable from "./components/Admin/AdminBilling/AdminBilling";
import AdminBilling from "./components/Admin/AdminBilling/ClientBills";
import AdmininsightsDashboard from "./components/Admin/AdminBilling/ClientInsights";
import WhitelistedClientsTable from "./components/Admin/Clients/AdminWhiteLabels";
import AdminOrderSettlement from "./components/Admin/Orders/AdminOrderSettlement";
import AdminSettlementAnalytics from "./components/Admin/Orders/AdminSettlementAnalytics";
import OrderSupport from "./components/Admin/Support/OrderSupport";
import AdminWrapper from "./components/Admin/AdminLogOut/AutologOut";
import AdminDining from "./components/Admin/Orders/AdminDining";
import AdminQrCode from "./components/Admin/Orders/AdminQrCode";
import AdminNewCatalogue from "./components/Admin/Orders/AdminCatalogue";
import AdminPosOrders from "./components/Admin/Orders/AdminPosOrders";
import AdminUpiPayment from "./components/Admin/AdminUpiPayment";
import AdminOrderController from "./components/Admin/Orders/AdminOrderController"
import AdminPaymentReports from "./components/Admin/Orders/AdminPaymentReports";
import AdminSubdomainTabs from "./components/Admin/Domains/AdminSubdomainTabs";
import AdminSupportTickets from "./components/Admin/Ticketing/AdminSupportTickets";
// Email Section Imports
import EmailChat from "./components/Email/EmailChat";
import EmailTemplate from "./components/Email/EmailTemplate";
import EmailCampaign from "./components/Email/EmailCampaign";
import EmailLogs from "./components//Email/EmailLogs";
import EmailStatus from "./components/Email/EmailStatus";
import EmailManagement from "./components/Email/EmailManagement";
import EmailBot from "./components/Email/EmailBot";
import ViewEmailTemplate from "./components/Email/ViewEmailTemplate";
import EmailCampaignView from "./components/Email/ViewEmailCampaign";
import EditEmailCampaign from "./components/Email/EditEmailCampaign";
import EmailEditor from "./components/Email/EmailEditor";

// Sms Section Imports
import SmsTemplateView from "./components/Sms/ViewSmsTemplate";
import SmsChat from "./components/Sms/SmsChat";
import SmsTemplate from "./components/Sms/SmsTemplate";
import SmsCampaign from "./components/Sms/SmsCampaign";
import SmsLogs from "./components/Sms/SmsLogs";
import SmsLibrary from "./components/Sms/SmsLibrary";
import SmsStatus from "./components/Sms/SmsStatus";
import SmsManagement from "./components/Sms/SmsManagement";
import SmsBot from "./components/Sms/SmsBot";
import EditSmsCampaign from "./components/Sms/EditSmsCampaign";
import SmsCampaignView from "./components/Sms/ViewSmsCampaign";

//Developer Section Imports
import Triggers from "./components/Developer/Triggers";
import Billing from "./components/Billing/Billing";

// inventory imports here
import InventoryManagment from "./components/Inventory/Inventory/InventoryManagment";
import Vendors from "./components/Inventory/Vendor/Vendors";
import GlobalInventory from "./components/Inventory/Global Invenbtory/GlobalInventory";
import CreatePurchase from "./components/Inventory/Inventory/CreatePurchase";
import BarcodeGenerator from "./components/Inventory/BarCode/BarcodeGenerator";
import EditIngredients from "./components/Order/EditIngredients";
import RackManager from "./components/Inventory/Racks/RackManager";

// import BarcodeGenerator from "./components/Inventory/BarCode/BarcodeGenerator";
// Profile Section Imports
import PlansAndPricing from "./components/Profile/Plans&Pricing";
import UserManagement from "./components/Profile/UserManagement";
import SupportCenter from "./components/Profile/SupportCenter";
import ProfileSetting from "./components/Profile/ProfileSetting";
import WelcomePage from "./components/Profile/WelcomePage";
import Setup from "./components/Profile/Setup";
import OrderSettings from "./components/Profile/OrderSettings";

// Other Imports Here
import Developer from "./components/Developer/Developer";
import IdentityPage from "./components/IdentityPage";
import NavigationBar from "./components/DesktopNav";
import ExpiredPlan from "./components/ExpiredPlan";
// import OrderAlert from './components/Contact Book/OrderAlert';
import SubscriptionBanner from "./components/SubscriptionBanner";
import Ledger from "./components/Billing/Ledger";
import FacebookOnBoarding from "./components/OnBoarding/FacebookOnBoarding";
import LabelPrinting from "./components/Order/POS/POS_LabelPrinting";

// Billing Section
// import Billing from "./components/Billing/Billing"
// import Billing2 from "./components/Billing/Billing2"

const TrackPageView = () => {
  const location = useLocation();
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
  return null;
};
// let beepSound = new Audio(beepSoundmp3);
// beepSound.loop = true;
// beepSound.load();
const App = () => {
  const [user, setUser] = useState(false);
  const [power, setPower] = useState("");
  const [profiles, setProfiles] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userID, setUserID] = useState("");
  const [DeveloperID, setDeveloperID] = useState("");
  const [keyId, setkeyId] = useState("");
  const [newOrderFlag, setNewOrderFlag] = useState(false);
  const [newOrderFlagUpdate, setNewOrderFlagUpdate] = useState(false);

  const handleNewOrder = () => {
    setNewOrderFlag(true);
    setTimeout(() => setNewOrderFlag(false), 2000); // Reset flag after 2s
  };
  const handleOrderUpdate = () => {
    setNewOrderFlagUpdate(true);
    setTimeout(() => setNewOrderFlagUpdate(false), 2000); // Reset flag after 2s
  };
  const handleAdminLogout = () => {
    setIsAdmin(false);
    sessionStorage.removeItem("AdminUser");
    window.location.href = "https://www.anlook.com/";
  };
  const [Admin, setAdmin] = useState();
  useEffect(() => {
    const checkAdminUser = () => {
      const storedUser = sessionStorage.getItem("AdminUser");
      if (storedUser) {
        setIsAdmin(true);
        setAdmin(storedUser);
      } else {
        setIsAdmin(false);
      }
    };
    checkAdminUser();
    window.addEventListener("storage", checkAdminUser);
    return () => {
      window.removeEventListener("storage", checkAdminUser);
    };
  }, []);
  const handleLogout = () => {
    setUser(false);
    sessionStorage.removeItem("user");
    window.location.href = "https://www.anlook.com/";
  };
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(true);
      const parsedUser = JSON.parse(storedUser);
      setUserID(parsedUser.userid);
      setDeveloperID(parsedUser.devloperId);
      setkeyId(parsedUser.keyId);
      setProfiles(parsedUser);
      console.log(parsedUser);
      console.log(DeveloperID);
      console.log(keyId);
    } else {
      // login();
      <Home onLoginClick={login} />;
    }
  }, []);

  const login = () => {
    const productId = "1";
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:3000"
        : "https://www.anlook.com";

    const callbackUrl = `${baseUrl}/identity`;
    const redirectUrl = `https://accounts.bumppy.com/?callback=${callbackUrl}&product_id=${productId}`;

    window.location.href = redirectUrl;
  };
  const signUp = () => {
    const productId = "1";
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:3000"
        : "https://www.anlook.com";

    const callbackUrl = `${baseUrl}/identity`;
    const redirectUrl = `https://accounts.bumppy.com/?callback=${callbackUrl}&product_id=${productId}&intent=signup`;

    window.location.href = redirectUrl;
  };
  useEffect(() => {
    const storedPower = sessionStorage.getItem("power");
    if (storedPower) {
      setPower(storedPower);
    }
  }, []);
  // Initialize Google Analytics
  useEffect(() => {
    initGA();
  }, []);
  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.anlook.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Identity",
        item: "https://www.anlook.com/identity",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Blogs",
        item: "https://www.anlook.com/blogs",
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "Post",
        item: "https://www.anlook.com/post",
      },
      {
        "@type": "ListItem",
        position: 5,
        name: "Pricing",
        item: "https://www.anlook.com/pricing",
      },
      {
        "@type": "ListItem",
        position: 6,
        name: "Contact",
        item: "https://www.anlook.com/contact",
      },
      {
        "@type": "ListItem",
        position: 7,
        name: "Privacy",
        item: "https://www.anlook.com/PrivacyPolicy",
      },
      {
        "@type": "ListItem",
        position: 8,
        name: "Terms & Conditions",
        item: "https://www.anlook.com/terms-and-conditions",
      },
      {
        "@type": "ListItem",
        position: 9,
        name: "Cancellation",
        item: "https://www.anlook.com/cancellation",
      },
      {
        "@type": "ListItem",
        position: 10,
        name: "About Us",
        item: "https://www.anlook.com/about-us",
      },
    ],
  };
  const [country, setCountry] = useState("");
  useEffect(() => {
    const storedCountry = sessionStorage.getItem("userCountry");
    if (!storedCountry) {
      // If no country in session storage, fetch location from API
      const fetchLocation = async () => {
        try {
          const response = await axios.get(
            `https://api.ipgeolocation.io/ipgeo?apiKey=1e4cf2d0a0ee4ebe92e18c3e52000ebf`
          );
          const userCountry = response.data.country_code2;
          setCountry(userCountry);
          sessionStorage.setItem("userCountry", userCountry);
        } catch (error) {
          console.error("Error fetching geolocation data:", error);
          setCountry("Other");
        }
      };
      fetchLocation();
    } else {
      // If country is stored in session storage, use it
      setCountry(storedCountry);
    }
  }, []);
  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
    sessionStorage.setItem("userCountry", selectedCountry);
  };
  return (
    <Router>

      {user && (
        <>
          <SubscriptionBanner userID={userID} />
        </>
      )}
      <TrackPageView />
      <div>
        {/* Admin */}
      <Routes>
          {" "}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<Login />} />
        </Routes>
      {isAdmin && (
          <>
            <AdminWrapper Admin={Admin} handleAdminLogout={handleAdminLogout}>
              <Routes>
                <Route
                  path="/admin/home"
                  element={<StatisticsDashboard Admin={Admin} />}
                />
                <Route
                  path="/admin/Clients"
                  element={<Clients Admin={Admin} />}
                />
                <Route
                  path="/admin/Logs"
                  element={<AdminCampaigns Admin={Admin} />}
                />
                <Route
                  path="/admin/ClientDashboard/:clientId"
                  element={<ClientAnalyticsDashboard Admin={Admin} />}
                />
                <Route
                  path="/admin/billing"
                  element={<ClientBillingTable Admin={Admin} />}
                />
                <Route
                  path="admin/campaign-logs"
                  element={<AdminCampaigns Admin={Admin} />}
                />
                <Route
                  path="/admin/support"
                  element={<Support Admin={Admin} />}
                />
                <Route
                  path="/admin/payout"
                  element={<PayoutSection Admin={Admin} />}
                />
                <Route
                  path="/admin/orders"
                  element={<AdminOrders Admin={Admin} />}
                />
                <Route
                  path="/admin/Blogs"
                  element={<AdminBlog Admin={Admin} />}
                />
                <Route
                  path="/admin/Allblogs"
                  element={<AdminAllBlogs Admin={Admin} />}
                />
                <Route
                  path="/admin/Editblogs"
                  element={<AdminEditBlogs Admin={Admin} />}
                />
                <Route
                  path="/admin/WhatsApp"
                  element={<WhatsAppLogs Admin={Admin} />}
                />
                <Route
                  path="/admin/AdminChat"
                  element={<ChatComponent Admin={Admin} />}
                />
                <Route
                  path="/admin/Authors"
                  element={<AdminAuthors Admin={Admin} />}
                />
                <Route
                  path="/admin/Leads/:clientId"
                  element={<AdminLeadManagement Admin={Admin} />}
                />
                <Route
                  path="/admin/LeadsDetails/:clientId"
                  element={<AdminLeadDetails Admin={Admin} />}
                />
                <Route
                  path="/admin/clientCatalogue/:clientId"
                  element={<AdminCatalogueTable Admin={Admin} />}
                />
                <Route
                  path="/admin/AddCatalogue/:clientId"
                  element={<AdminCatalogue Admin={Admin} />}
                />
                <Route
                  path="/admin/Campaigns/:clientId"
                  element={<AdminCampaign Admin={Admin} />}
                />
                <Route
                  path="/admin/campaignview/:clientId/:number/:CampaignId/:campaignName"
                  element={<AdminCampaignView Admin={Admin} />}
                />
                <Route
                  path="/admin/CampaignEdit/:clientId/:campaignId"
                  element={<AdminEditCampaign Admin={Admin} />}
                />
                <Route
                  path="/admin/Templates/:clientId"
                  element={<AdminTemplate Admin={Admin} />}
                />
                <Route
                  path="/admin/TemplatesView/:clientId/:templateId"
                  element={<AdminTemplateView Admin={Admin} />}
                />
                <Route
                  path="/admin/billing/bill/:clientId/:clientName"
                  element={<AdminBilling Admin={Admin} />}
                />
                <Route
                  path="/admin/billing/insights/:clientId/:clientName"
                  element={<AdmininsightsDashboard Admin={Admin} />}
                />
                <Route
                  path="/admin/order/orderssettings"
                  element={<AdminOrdersSetting Admin={Admin} />}
                />
                <Route
                  path="/Orders/Menu"
                  element={
                    <CatalogueTable
                      userID={userID}
                      DeveloperID={DeveloperID}
                      keyId={keyId}
                    />
                  }
                />
                <Route
                  path="/admin/white-labels"
                  element={<WhitelistedClientsTable Admin={Admin} />}
                />
                <Route
                  path="/admin/orders/settlement"
                  element={<AdminOrderSettlement Admin={Admin} />}
                />
                <Route
                  path="/admin/orders/settlement/:clientId/:clientName"
                  element={<AdminSettlementAnalytics Admin={Admin} />}
                />
                <Route
                  path="/admin/orders/settlement/Report/:clientId/:clientName"
                  element={<AdminPaymentReports Admin={Admin} />}
                />
                <Route
                  path="/admin/Support/Orders"
                  element={<OrderSupport Admin={Admin} />}
                />
                <Route
                  path="/admin/Support/Tickets"
                  element={<AdminSupportTickets Admin={Admin} />}
                />
                <Route
                  path="/admin/orders/Catalogue"
                  element={<AdminNewCatalogue Admin={Admin} />}
                />
                <Route
                  path="/admin/orders/Dinning"
                  element={<AdminDining Admin={Admin} />}
                />
                <Route
                  path="/admin/orders/Dinning/:clientId/:clientName"
                  element={<AdminQrCode Admin={Admin} />}
                />
                <Route
                  path="/admin/orders/Pos"
                  element={<AdminPosOrders Admin={Admin} />}
                />
                <Route
                  path="/admin/upi-report"
                  element={<AdminUpiPayment Admin={Admin} />}
                />
                <Route
                  path="/admin/orders/PosOrders"
                  element={<AdminOrderController Admin={Admin} />}
                />
                <Route
                  path="/admin/chaafo"
                  element={<AdminSubdomainTabs Admin={Admin} />}
                />
              </Routes></AdminWrapper>


          </>
        )}

        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(breadcrumbData)}
          </script>
        </Helmet>
        <Routes>
          {!user && (
            <>
              <Route path="/get" element={<MyLanding onLoginClick={login} />} />
              <Route
                path="/get/BuyPlan"
                element={<BuyPlan onLoginClick={login} />}
              />

              <Route
                path="/get/GetStarted"
                element={<GetStarted onLoginClick={login} />}
              />

              <Route
                path="/"
                element={
                  <Home
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/identity"
                element={
                  <IdentityPage
                    power={power}
                    setUser={setUser}
                    setPower={setPower}
                  />
                }
              />

              <Route
                path="/blog"
                element={
                  <Blogs
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/blog/:post_slug"
                element={
                  <Post
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/pricing"
                element={
                  <Pricing
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/author/:Author"
                element={
                  <Author
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/contact"
                element={
                  <Contact
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/PrivacyPolicy"
                element={
                  <Privacy
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/terms&conditions"
                element={
                  <TAndC
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/Cancellation"
                element={
                  <Cancellation
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/AboutUs"
                element={
                  <LandingAbout
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
            </>
          )}
        </Routes>
        {user ? (
          <>
            <NavigationBar
              setUser={setUser}
              handleLogout={handleLogout}
              userID={userID}
            />
            <OrderWebSocket userID={userID} onNewOrder={handleNewOrder} />
            <OrderUpdateWebSocket userID={userID} onOrderUpdate={handleOrderUpdate} />
            {/* <OrderList newOrderFlag={newOrderFlag} /> */}
            <div style={{ flex: 1, paddingLeft: "145px" }}>
              <Routes>
                {power === "1" ? (
                  <>
                    <Route
                      path="/Dashboard"
                      element={
                        <Dashboard
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    {/* <Route
                      path="/Dashboard2"
                      element={
                        <Dashboard2
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    /> */}
                    <Route
                      path="/WhatsApp/Create-Template"
                      element={
                        <CreateTemplate
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp"
                      element={
                        <Chats
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ContactBook"
                      element={
                        <ContactBook
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ChatBot"
                      element={
                        <ChatBotMain
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ChatBotStop"
                      element={
                        <ChatBot
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Campaign"
                      element={
                        <CreateCampaign
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/CampaignTool"
                      element={
                        <CreateCampaignTool
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Template"
                      element={
                        <DLTTamplate
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Manage"
                      element={
                        <Campaign
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                      <Route
                      path="/WhatsApp/Manage1"
                      element={
                        <CampaignTool
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Logs"
                      element={
                        <Logs
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Insights"
                      element={
                        <CampaignInsights
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateLibrary"
                      element={
                        <TemplateLibrary
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateLibrary/Edit"
                      element={
                        <EditLibrary
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/feed"
                      element={
                        <FaceBookFeed
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/post"
                      element={
                        <AllPost
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook"
                      element={
                        <Friends
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/Create-Template"
                      element={
                        <FbTamplate
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/Campaign"
                      element={
                        <FbCampaign
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/Template"
                      element={
                        <FbTamplateStatus
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/Manage"
                      element={
                        <FbCampaignStatus
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/Logs"
                      element={
                        <FbLogs
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/TemplateLibrary"
                      element={
                        <FbTemplateLibrary
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/facebook/ChatBot"
                      element={
                        <FbChatBot
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders"
                      element={
                        <Order
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                          newOrderFlag={newOrderFlag}
                          newOrderFlagUpdate={newOrderFlagUpdate}
                        />
                      }
                    />
                    <Route
                      path="/Orders/Dinning"
                      element={
                        <Dining
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                      <Route
                      path="/Orders/QR_Code"
                      element={
                        <TableQRCode
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/DoorDash"
                      element={
                        <DoorDash
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/AddCatalogue"
                      element={
                        <Catalogue
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/Catalogue"
                      element={
                        <CatalogueTable
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/Gallery"
                      element={
                        <OrderGallery
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/Reports"
                      element={
                        <ReportSection
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                        <Route
                      path="/Pos/Pos"
                      element={
                        <POS
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                           <Route
                      path="/Pos/Settings"
                      element={
                        <POSOrderSetting
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                       <Route
                      path="/Pos/Orders"
                      element={
                        <POSOrderHistory
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                       <Route
                      path="/Pos/Labels"
                      element={
                        <LabelPrinting
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    
                         <Route
                      path="/Orders/POS"
                      element={
                        <POS
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/Menu"
                      element={
                        <CatalogueTable
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/Delivery"
                      element={
                        <Delivery
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/BlockUser"
                      element={
                        <BlockUser
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/Payments"
                      element={
                        <Payment
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/Payouts"
                      element={
                        <PayOut
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/OrderSummary"
                      element={
                        <OrderSummary
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Orders/OrderSettings"
                      element={
                        <OrderSettingsCharges
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Analytics"
                      element={
                        <Analytics
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Developer"
                      element={
                        <Developer
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Developer/triggers"
                      element={
                        <Triggers
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Analytics/Leads"
                      element={
                        <LeadManagement
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Analytics/LeadDetails"
                      element={
                        <LeadDetails
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />

                    <Route
                      path="/Billing"
                      element={
                        <Billing
                          userID={userID}
                          profiles={profiles}
                          keyId={keyId}
                        />
                      }
                    />
                     <Route
                      path="/Billing/Ledger"
                      element={
                        <Ledger
                          userID={userID}
                          profiles={profiles}
                          keyId={keyId}
                        />
                      }
                    />
                    {/* <Route
                      path="/Profile"
                      element={
                        <Billing profiles={profiles} power={power}  DeveloperID={DeveloperID} keyId={keyId} />
                      }
                    /> */}
                    <Route
                      path="/Profile"
                      element={
                        <ProfileSetting
                          profiles={profiles}
                          power={power}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/Setting"
                      element={
                        <OrderSettings
                          profiles={profiles}
                          power={power}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/Integration"
                      element={<DoorDash userID={userID} />}
                    />
                    <Route
                      path="/Profile/Plans"
                      element={
                        <PlansAndPricing
                          userID={userID}
                          country={country}
                          handleCountryChange={handleCountryChange}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/Setup"
                      element={
                        <Setup
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/UserManagement"
                      element={
                        <UserManagement
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/SupportCenter"
                      element={
                        <SupportCenter
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/CampaignDetails"
                      element={
                        <CampaignDetails
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Manage/CampaignView"
                      element={
                        <CampaignView
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateView"
                      element={
                        <TemplateView
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Template/TemplateEdit"
                      element={
                        <TemplateEdit
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/WelcomePage"
                      element={
                        <WelcomePage
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/ExpiredPlan"
                      element={
                        <ExpiredPlan
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Onboarding"
                      element={
                        <FacebookOnBoarding
                          userID={userID}
                          profiles={profiles}
                        />
                      }
                    />
                    <Route
                      path="/Email"
                      element={
                        <EmailChat
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Campaign"
                      element={
                        <EmailCampaign
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Create-Template"
                      element={
                        <EmailTemplate
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Manage"
                      element={
                        <EmailManagement
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Manage/View"
                      element={
                        <EmailCampaignView
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Manage/Edit"
                      element={
                        <EditEmailCampaign
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Logs"
                      element={
                        <EmailLogs
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Template"
                      element={
                        <EmailStatus
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Template/:TemplateId"
                      element={
                        <ViewEmailTemplate
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/ChatBot"
                      element={
                        <EmailBot
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Email/Editor"
                      element={
                        <EmailEditor
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/SMS"
                      element={
                        <SmsChat
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/sms/Campaign"
                      element={
                        <SmsCampaign
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Sms/Create-Template"
                      element={
                        <SmsTemplate
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Sms/Manage"
                      element={
                        <SmsManagement
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Sms/Logs"
                      element={
                        <SmsLogs
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Sms/Template"
                      element={
                        <SmsStatus
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Sms/ChatBot"
                      element={
                        <SmsBot
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Sms/Manage/View"
                      element={
                        <SmsCampaignView
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Sms/Manage/Edit"
                      element={
                        <EditSmsCampaign
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Sms/Template/:TemplateId"
                      element={
                        <SmsTemplateView
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    
     <Route
                      path="/Inventory/Inventory" 
                      element={
                        <InventoryManagment
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }


                    />
                    <Route
                      path="/Inventory/Vendors"
                      element={
                        <Vendors
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }


                    />
                        <Route
                      path="/Inventory/Vendors/CreatePurchase"
                      element={
                        <CreatePurchase
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }


                    />
                    <Route
                      path="/Inventory/Racks"
                      element={
                        <RackManager
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }


                    />
                    <Route
                      path="/Inventory/Global"
                      element={
                        <GlobalInventory
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                       />
                         <Route
                      path="/Support/Tickets"
                      element={
                        <SupportTickets
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                       />
                       <Route
                      path="/Orders/Catalogue/edit-ingredients/:itemId"
                      element={
                        <EditIngredients
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                        
                      }
                    />

                    <Route
                      path="/Orders/Credits"
                      element={
                        <CreditTabs
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                     <Route
                      path="/Orders/Vendors"
                      element={
                        <VendorManager
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                  </>
                ) : (
                  <>
                    {/* <Navigate to="/Profile" replace /> */}
                    <Route
                      path="/ExpiredPlan"
                      element={
                        <ExpiredPlan
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile"
                      element={
                        <ProfileSetting
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/Plans"
                      element={
                        <PlansAndPricing
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/Setup"
                      element={
                        <Setup
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/WelcomePage"
                      element={
                        <WelcomePage
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/UserManagement"
                      element={
                        <UserManagement
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/Technical_Setting"
                      element={
                        <PlansAndPricing
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                  </>
                )}
              </Routes>
            </div>
          </>
        ) : (
          <Routes>
            {/* <Route path="/" element={<Login login={login} />} /> */}
          </Routes>
        )}
      </div>
    </Router>
  );
};

export default App;
